/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import * as _ from 'lodash'
import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { TotalTabWrap } from '@styles/base.style'
import { Tabs } from 'antd-mobile'
import { Models } from 'rmc-tabs'
import useRootStore from '@store/useRootStore'
import { useOnUnmount } from '@utils/reactExt'
import { UserPickLikeActivity } from '@views/MyPage/UserActivity/LikeActivity/UserPickLikeActivity'
import PopupUtils from '@utils/popup-utils'
import { Schema$CompanyPick } from '@interface/company-pick'
import { CompanyPickLikeActivity } from '@views/MyPage/UserActivity/LikeActivity/CompanyPickLikeActivity'

enum USER_ACTIVITY_TAB_KEY {
  USER_PICK_LIKE = 'user-pick-like',
  COMPANY_PICK_LIKE = 'company-pick-like',
}

export interface LikeActivityProps {
  title: string
  initTabIndex?: number
  companyPick?: Schema$CompanyPick
  baseMonth?: string
}

export const LikeActivity: React.FC<LikeActivityProps> = observer((props) => {
  const { userPickStore, userStore } = useRootStore()
  const { initTabIndex = 0, title, baseMonth } = props
  const [currentTabKey, setCurrentTabKey] = useState(
    initTabIndex === 0 ? USER_ACTIVITY_TAB_KEY.USER_PICK_LIKE : USER_ACTIVITY_TAB_KEY.COMPANY_PICK_LIKE,
  )
  const { myActivity } = userStore

  useOnUnmount(() => {
    userPickStore.resetUserPickMine()
  })

  useEffect(() => {
  PopupUtils.changePopupTitle('my-like-activity-list', `${title}`)
  }, [title])

  let userPickLikedCount = 0
  let companyPickLikedCount = 0
  if (_.isNil(baseMonth)) {
    companyPickLikedCount = myActivity?.totalCompanyPickLikedCount
    userPickLikedCount = myActivity?.totalUserPickLikedCount
  } else {
    companyPickLikedCount = myActivity?.monthlyCompanyPickLikedCount
    userPickLikedCount = myActivity?.monthlyUserPickLikedCount
  }

  const userActivityTabList = useMemo(() => {
    return [
      {
        title: (
          <span className="tab-item large-txt">
            <span className="txt">나도 승부사 분석글</span>
            <span className="num">{userPickLikedCount}</span>
          </span>
        ),
        name: '나도 승부사 분석글',
        key: USER_ACTIVITY_TAB_KEY.USER_PICK_LIKE,
      },
      {
        title: (
          <span className="tab-item large-txt">
            <span className="txt">프리미엄 분석가 분석글</span>
            <span className="num">{companyPickLikedCount}</span>
          </span>
        ),
        name: '프리미엄 분석가 분석글',
        key: USER_ACTIVITY_TAB_KEY.COMPANY_PICK_LIKE,
      },
    ]
  }, [myActivity])

  const onChange = (tab: Models.TabData) => {
    setCurrentTabKey(tab.key as USER_ACTIVITY_TAB_KEY)
  }

  let contents
  switch (currentTabKey) {
    case USER_ACTIVITY_TAB_KEY.USER_PICK_LIKE:
      contents = <UserPickLikeActivity baseMonth={baseMonth}/>
      break
    case USER_ACTIVITY_TAB_KEY.COMPANY_PICK_LIKE:
      contents = <CompanyPickLikeActivity baseMonth={baseMonth}/>
      break
  }

  return (
    <Fragment>
      <TotalTabWrap underline className="my-like-activity-list">
        <Tabs
          tabs={userActivityTabList}
          initialPage={initTabIndex}
          page={currentTabKey}
          onChange={onChange}
        />
      </TotalTabWrap>
      {contents}
    </Fragment>
  )
})
